import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { getNews } from '../../api/backend'



const SubmitHandler = (e) => {
    e.preventDefault()
}

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSidebar = (props) => {
    const [blogs, setBlogs] = useState([])

    useEffect(() => {
        getNews()
            .then(res => setBlogs(res.data || []))
            .catch(err => console.error('Errore sidebar news:', err))
    }, [])

    return (
        <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
            <div className="blog-sidebar">

                {/*<div className="widget search-widget">*/}
                {/*    <h3>Search Here</h3>*/}
                {/*    <form onSubmit={SubmitHandler}>*/}
                {/*        <div>*/}
                {/*            <input type="text" className="form-control" placeholder="Search Post.." />*/}
                {/*            <button type="submit"><i className="ti-search"></i></button>*/}
                {/*        </div>*/}
                {/*    </form>*/}
                {/*</div>*/}
               
                <div className="widget recent-post-widget">
                    <h3>Posts</h3>
                    <div className="posts">
                        {blogs.slice(0, 3).map((blog, bl) => (
                            <div className="post" key={blog.id || bl}>
                                {blog.image_url && (
                                    <div className="img-holder">
                                        <img src={blog.image_url} alt="" />
                                    </div>
                                )}
                                <div className="details">
                                    <h4><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h4>
                                    <span className="date">{blog.formatted_date}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="widget tag-widget">
                    <h3>Tags</h3>
                    <ul>
                        {Array.from(
                            new Map(
                                blogs.flatMap(blog => (blog.tags || []).map(tag => [tag.name, tag]))
                            ).values()
                        ).map((tag, i) => (
                            <li key={i}><Link onClick={ClickHandler} to={`/blog/tag/${encodeURIComponent(tag.name)}`}>{tag.name}</Link></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )

}

export default BlogSidebar;
